<template>
  <router-view />
</template>
<script>
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import additionalExamModule from '@/store/additional-exam'
import additionalExamCheckModule from '@/store/additional-exam-check'

export default {
  setup() {
    const MODULE_NAME = 'additionalExam'
    const MODULE_CHECK = 'additionalExamCheck'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, additionalExamModule)
    if (!store.hasModule(MODULE_CHECK)) store.registerModule(MODULE_CHECK, additionalExamCheckModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
      if (store.hasModule(MODULE_CHECK)) store.unregisterModule(MODULE_CHECK)
    })
  },
}
</script>
